<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">通讯录</a></li>
                <li><a href="#">修改提醒</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
  	        <div class="formbody">    
                <div class="formtitle"><span>修改提醒</span></div>    
                <ul class="forminfo">    
                    <li><label>新增标题</label>
                        <input name="" v-model="txtitle" type="text" class="dfinput left maringht10" />
                    </li>     
                    <li><label>提交内容</label>
                        <textarea name="" v-model="txcontent" cols="" rows="" class="textinput left maringht10"></textarea>
                    </li>
     
                    <li><label>提醒类型</label>
                    <div class="cityleft">
                        <el-select v-model="txtype" placeholder="请选择">
                            <el-option
                            v-for="item in tixingtypeList"
                            :key="item.id"
                            :label="item.txtypename"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="buttonupload click">新增提醒类型</div>
                    </li>
    
                    <li>
                        <label>提醒方式</label>
                        <cite class="left">
                            <input name="txmethod" type="radio" @change="changeTxMethod(1)" v-model="txmethod" value="1" />单次提醒
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input name="txmethod" type="radio" @change="changeTxMethod(2)" v-model="txmethod" value="2" />每天提醒
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input name="txmethod" type="radio" @change="changeTxMethod(3)" v-model="txmethod" value="3" />每周提醒
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input name="txmethod" type="radio" @change="changeTxMethod(4)" v-model="txmethod" value="4" />每月提醒
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input name="txmethod" type="radio" @change="changeTxMethod(5)" v-model="txmethod" value="5" />每年提醒
                        </cite>
                    </li>
                    <li><label>提醒时间</label>    
                        <div class="cityleft" v-show="showList[0].isShow">
                            <el-date-picker v-model="txtime_dc" :picker-options="pickerBeginDateAfter"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="提醒时间" />
                        </div>                    
                        <cite class="left"  v-show="showList[1].isShow">
                            每天：<el-time-select v-model="txtime_mt_hm"
                                    :picker-options="{
                                        start: '08:00',
                                        step: '00:15',
                                        end: '22:00'
                                    }"
                                    placeholder="选择时间">
                            </el-time-select>
                        </cite>
                        <cite class="left"  v-show="showList[2].isShow">
                            每周：<el-select v-model="txtime_mz_weekday" placeholder="请选择">
                                <el-option v-for="item in weekdayList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-time-select v-model="txtime_mz_hm"
                                :picker-options="{
                                    start: '08:00',
                                    step: '00:15',
                                    end: '22:00'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </cite>
                        <cite class="left"  v-show="showList[3].isShow">
                            <el-select v-model="txtime_my_day" placeholder="请选择">
                                <el-option v-for="item in dayList" :key="item.value" :label="'每月' + item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-time-select v-model="txtime_my_hm"
                                :picker-options="{
                                    start: '08:00',
                                    step: '00:15',
                                    end: '22:00'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </cite>
                        <cite class="left"  v-show="showList[4].isShow">
                            <el-select v-model="txtime_mn_month" placeholder="请选择">
                                <el-option v-for="item in monthList" :key="item.value" :label="'每年' + item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-select v-model="txtime_mn_day" placeholder="请选择">
                                <el-option v-for="item in dayList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-time-select v-model="txtime_mn_hm"
                                :picker-options="{
                                    start: '08:00',
                                    step: '00:15',
                                    end: '22:00'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </cite>
                    </li>    
                    <li>
                        <label>提醒方式</label>
                            <cite class="left">
                            <input name="sendmethod" v-model="sendmethod" type="radio" value="1" checked="checked" />短信提醒            &nbsp;&nbsp;&nbsp;&nbsp;
                        </cite>
                    </li>
    
    
                    <li><label>提醒号码</label>
                        <input name="" type="text" v-model="mobile" class="dfinput left maringht10" /> 
                        <div class="buttonupload  click1">从通讯录中添加</div>
                    </li>
    
                    <li><label>&nbsp;</label><input name="" @click="updTiXing()" type="button" class="btn" value="保存修改"/></li>
     
                </ul>
    
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>提醒说明</b>
                </div>
    
                <ul class="infolist">
                    <li>免费提醒：每年可免费短信/语音提醒50次(条或分钟)，每月最多免费20次(条或分钟)，限提醒本人手机号（分机1）；</li>
                    <li>付费提醒：超出次/条或提醒其他号码需收费； 短信提醒按0.1元/60字/条计费，语音提醒0.2元/分钟</li>
                </ul>
            </div> 
  	
	    </div> 
    
        <!--tip2-->
        <div class="tip tip2">
        
    	<div class="tiptop"><span>添加提醒类型</span><a></a></div>
        
        <div class="tipinfo cen ovhi">
      
        <div class="cen ovhi pat20">
         <input name="" type="text" class="scinput" style="width:280px;"/>
        </div>
        
        <div class="cen lh33 ovhi">请填写提醒名称。</div>
        
        <div class="cen pat20 ovhi">
        <input name="" type="button"  class="sure"  value="确定" />&nbsp;
        <input name="" type="button"  class="cancel"  value="取消" />
        </div>
    
        </div>
    
        </div>
        
         <!--tip1-->
        <div class="tip tip1">
        
    	<div class="tiptop"><span>云验证-通讯录</span><a></a></div>
        
        <div class="tipinfo cen ovhi">
      
        <div class="cen ovhi">
        <label class="left lh33">选择组 &nbsp; </label>
        <div class="cityleft">
	    <select class="select2">
        <option value="">全部通信录</option>
	    <option value="1496478">快递到</option>
	    <option value="1496471">校友</option>
	    <option value="5229">家人</option>
	    <option value="5228">同事</option>
	    <option value="5223">客户</option>
        </select>
       </div>
       </div>
        
        <table class="tablelist">
    	<thead>
    	<tr>
        <th>姓名</th>
        <th>号码</th>
        </tr>
        </thead>
        <tbody>
        
        <tr >
        <td>海航</td>
        <td>158445856250</td>
        </tr> 

        </tbody>
        </table>
        
        <div class="cen pat20 ovhi">
        <input name="" type="button"  class="sure"  value="确定" />&nbsp;
        <input name="" type="button"  class="cancel"  value="取消" />
        </div>
    
        </div>
    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            id:this.$route.query.id,
            txtitle:'', //提醒标题
            txcontent:'',//提醒内容
            tixingtypeList:[],
            txtype:'',
            txmethod:'1',
            showList:[
                {"isShow":true},{"isShow":false},{"isShow":false},{"isShow":false},{"isShow":false}
            ],            
            txnexttime:'', //下次提醒的时间
            txtime_dc:'', //单次提醒的时间
            txtime_mt_hm:'', //每天提醒设置中的小时分钟
            txtime_mz_weekday:'',//每周提醒设置中的周几
            txtime_mz_hm:'', //每周提醒设置中的小时分钟
            txtime_my_day:'',//每月提醒设置中的几号
            txtime_my_hm:'',//每月提醒设置中的小时分钟
            txtime_mn_month:'',//每年设置中的月份
            txtime_mn_day:'',//每年设置中的几号
            txtime_mn_hm:'',//每年设置中的小时分钟
            pickerBeginDateAfter: {
                disabledDate: (time) => {
                    let beginDateVal = this.txnexttime;
                    if (beginDateVal) {
                        return time.getTime() <= Date.now();
                    }
                }
            },
            sendmethod:'1',
            weekday:'',
            day:'',
            month:'',
            year:'',
            hours:'',
            minutes:'',
            txmethoddesc:'',
            mobile:'',
            weekdayList:[
                {label:'周日',value:'0'},{label:'周一',value:'1'},{label:'周二',value:'2'},{label:'周三',value:'3'},
                {label:'周四',value:'4'},{label:'周五',value:'5'},{label:'周六',value:'6'}
            ],
            monthList:[
                {label:'1月',value:'1'},{label:'2月',value:'2'},{label:'3月',value:'3'},{label:'4月',value:'4'},
                {label:'5月',value:'5'},{label:'6月',value:'6'},{label:'7月',value:'7'},{label:'8月',value:'8'},
                {label:'9月',value:'9'},{label:'10月',value:'10'},{label:'11月',value:'11'},{label:'12月',value:'12'},
            ],
            dayList:[
                {label:'1日',value:'1'},{label:'2日',value:'2'},{label:'3日',value:'3'},{label:'4日',value:'4'},{label:'5日',value:'5'},{label:'6日',value:'6'},
                {label:'7日',value:'7'},{label:'8日',value:'8'},{label:'9日',value:'9'},{label:'10日',value:'10'},{label:'11日',value:'11'},{label:'12日',value:'12'},
                {label:'13日',value:'13'},{label:'14日',value:'14'},{label:'15日',value:'15'},{label:'16日',value:'16'},{label:'17日',value:'17'},{label:'18日',value:'18'},
                {label:'19日',value:'19'},{label:'20日',value:'20'},{label:'21日',value:'21'},{label:'22日',value:'22'},{label:'23日',value:'23'},{label:'24日',value:'24'},
                {label:'25日',value:'25'},{label:'26日',value:'26'},{label:'27日',value:'27'},{label:'28日',value:'28'},{label:'29日',value:'29'},{label:'30日',value:'30'},{label:'31日',value:'31'}
            ]
        }
    },
    mounted(){
        this.getRemindType();
        this.getTiXingDetail();
    },
    methods:{
        getRemindType(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/tixingtype.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.tixingtypeList = res.data.tixingtypeList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getTiXingDetail(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/gettixingdetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txtitle = res.data.tixing.txtitle;
                    that.txcontent = res.data.tixing.txcontent;
                    that.txtype = res.data.tixing.txtype;
                    that.txmethod = res.data.tixing.txmethod;
                    that.sendmethod = res.data.tixing.sendmethod;
                    that.mobile = res.data.tixing.mobile;
                    that.changeTxMethod(res.data.tixing.txmethod);
                    if(1 == that.txmethod){
                        that.txtime_dc = res.data.tixing.nexttime;
                    }
                    else if(2 == that.txmethod){
                        that.txtime_mt_hm = (parseInt(res.data.tixing.hours)<10?'0'+parseInt(res.data.tixing.hours):parseInt(res.data.tixing.hours))+':'+(parseInt(res.data.tixing.minutes)<10?'0'+parseInt(res.data.tixing.minutes):parseInt(res.data.tixing.minutes));
                    }
                    else if(3 == that.txmethod){
                        that.txtime_mz_weekday = res.data.tixing.weekday;
                        that.txtime_mz_hm = (parseInt(res.data.tixing.hours)<10?'0'+parseInt(res.data.tixing.hours):parseInt(res.data.tixing.hours))+':'+(parseInt(res.data.tixing.minutes)<10?'0'+parseInt(res.data.tixing.minutes):parseInt(res.data.tixing.minutes));
                    }
                    else if(4 == that.txmethod){
                        that.txtime_my_day = res.data.tixing.day;
                        that.txtime_my_hm = (parseInt(res.data.tixing.hours)<10?'0'+parseInt(res.data.tixing.hours):parseInt(res.data.tixing.hours))+':'+(parseInt(res.data.tixing.minutes)<10?'0'+parseInt(res.data.tixing.minutes):parseInt(res.data.tixing.minutes));
                    }
                    else if(5 == that.txmethod){
                        that.txtime_mn_month = res.data.tixing.month;
                        that.txtime_mn_day = res.data.tixing.day;
                        that.txtime_mn_hm = (parseInt(res.data.tixing.hours)<10?'0'+parseInt(res.data.tixing.hours):parseInt(res.data.tixing.hours))+':'+(parseInt(res.data.tixing.minutes)<10?'0'+parseInt(res.data.tixing.minutes):parseInt(res.data.tixing.minutes));
                    }
                    //that.tixingtypeList = res.data.tixingtypeList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changeTxMethod(txmethod){
            this.showList.forEach(function(obj){
                //  obj.isActive = false;   
                 obj.isShow = false;   
            });
            this.showList[txmethod -1].isShow = true;
        },
        updTiXing(){
            if(this.txtitle.trim() == ''){
                alert("提醒标题不能为空！");
                return;
            }
            if(this.txtitle.trim() == ''){
                alert("提醒内容不能为空！");
                return;
            }
            if(this.txtype == ''){
                alert("提醒类型不能为空！");
                return;
            }
            var myDate = new Date();
            var nowyear = myDate.getFullYear();
            var nowmonth = myDate.getMonth()+1;
            var nowdate = myDate.getDate();
            var nowhours = myDate.getHours();
            var nowminutes = myDate.getMinutes();
            var nowtime = nowyear +'-'+ (nowmonth<10?"0"+nowmonth:nowmonth)+ '-' + (nowdate<10?"0"+nowdate:nowdate) + ' ' + (nowhours<10?"0"+nowhours:nowhours) + ':' + (nowminutes<10?"0"+nowminutes:nowminutes) + ':00';
            // console.log(nowtime);
            if(this.txmethod == 1){
                //单次提醒
                if(this.txtime_dc==''){
                    alert("请选择单次提醒的时间！");
                    return;
                }
                // console.log(this.txtime_dc + '\r\n' + nowtime);
                if(this.txtime_dc <= nowtime){
                    alert("提醒时间必须大于当前时间！");
                    return;
                }
                this.txnexttime = this.txtime_dc;
                var dcDate = new Date(this.txtime_dc);
                this.year = dcDate.getFullYear();
                this.month = dcDate.getMonth()+1;
                this.day = dcDate.getDate();
                this.hours = dcDate.getHours();
                this.minutes = dcDate.getMinutes();
                this.txmethoddesc = '[单次]' + this.year + '年' + (this.month<10?'0'+this.month:this.month) + '月' + (this.day<10?'0'+this.day:this.day) + '日' + (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
            }
            else if(this.txmethod == 2){
                //每天提醒
                if( this.txtime_mt_hm <= (nowhours<10?'0'+nowhours:nowhours) + '' + (nowminutes<10?'0'+nowminutes:nowminutes) ){
			
                    nowdate = nowdate + 1;
                    if( nowmonth==1 || nowmonth==3 || nowmonth==5 || nowmonth==7 || nowmonth==8 || nowmonth==10 || nowmonth==12 ){
                        if( nowdate > 31 ){
                            nowdate = 1;
                            nowmonth = nowmonth + 1;
                        }
                        if( nowmonth > 12 ){
                            nowmonth = 1;
                            nowyear = nowyear + 1;
                        }
                    }else if( nowmonth==4 || nowmonth==6 || nowmonth==9 || nowmonth==11 ){
                        if( nowdate > 30 ){
                            nowdate = 1;
                            nowmonth = nowmonth + 1;
                        }
                        if( nowmonth > 12 ){
                            nowmonth = 1;
                            nowyear = nowyear + 1;
                        }
                    }else{
                        if( nowdate > 28 ){
                            nowdate = 1;
                            nowmonth = nowmonth + 1;
                        }
                        if( nowmonth > 12 ){
                            nowmonth = 1;
                            nowyear = nowyear + 1;
                        }
                    }			
                }
                var nexttime = nowyear + '-' + (nowmonth<10?'0'+nowmonth:nowmonth) + '-' + (nowdate<10?'0'+nowdate:nowdate) + ' ' + this.txtime_mt_hm + ":00";
                this.txnexttime = nexttime;
                this.hours = new Date(this.txnexttime).getHours();
                this.minutes = new Date(this.txnexttime).getMinutes();
                if( this.hours >= 0 && this.hours < 6 ){
	 		        this.txmethoddesc = '[重复]每天凌晨'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours>= 6 && this.hours < 9 ){
                    this.txmethoddesc = '[重复]每天早上'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours >= 9 && this.hours < 12 ){
                    this.txmethoddesc = '[重复]每天上午'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours == 12 ){
                    this.txmethoddesc = '[重复]每天中午'+ this.hours + ':' + this.minutes;
                }else if ( this.hours > 12 && this.hours < 18 ){
                    this.txmethoddesc = '[重复]每天下午'+(this.hours-12) + ':' + this.minutes;
                }else if( this.hours >= 18 && this.hours <22 ){
                    this.txmethoddesc = '[重复]每天晚上'+(this.hours-12) + ':' + this.minutes;
                }else{
                    this.txmethoddesc = '[重复]每天深夜'+(this.hours-12) + ':' + this.minutes;
                }
                this.day = 1;
            }
            else if(this.txmethod == 3){
                //每周
                var weekday = myDate.getDay();//获取当前星期X(0-6,0代表星期天)
                if( weekday == this.txtime_mz_weekday ){
                    if( this.txtime_mz_hm <= (nowhours<10?'0'+nowhours:nowhours) + ':' + (nowminutes<10?'0'+nowminutes:nowminutes) ){
                        nowdate = nowdate + 7;				
                    }
                }else if( weekday < this.txtime_mz_weekday ){
                    nowdate = nowdate + (this.txtime_mz_weekday - weekday);			
                }else if( weekday > this.txtime_mz_weekday ){			
                    nowdate = parseInt(nowdate) + ( 7 - parseInt(weekday) + parseInt(this.txtime_mz_weekday) );
                }
                if( nowmonth==1 || nowmonth==3 || nowmonth==5 || nowmonth==7 || nowmonth==8 || nowmonth==10 || nowmonth==12 ){
                    if( nowdate > 31 ){
                        nowdate = 1;
                        nowmonth = nowmonth + 1;
                    }			
                }else if( nowmonth==4 || nowmonth==6 || nowmonth==9 || nowmonth==11 ){
                    if( nowdate > 30 ){
                        nowdate = 1;
                        nowmonth = nowmonth + 1;
                    }
                }else{
                    if( nowdate > 28 ){
                        nowdate = 1;
                        nowmonth = nowmonth + 1;
                    }
                }
                if( nowmonth > 12 ){
                    nowmonth = 1;
                    nowyear = nowyear + 1;
                }
                
                var nexttime = nowyear + '-' + (nowmonth<10?'0'+nowmonth:nowmonth) + '-' + (nowdate<10?'0'+nowdate:nowdate) + ' ' + this.txtime_mz_hm + ':00';
                this.txnexttime = nexttime;
                this.hours = new Date(this.txnexttime).getHours();
                this.minutes = new Date(this.txnexttime).getMinutes();
                this.weekday = this.txtime_mz_weekday;
                if( this.hours >= 0 && this.hours < 6 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '凌晨'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours>= 6 && this.hours < 9 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '早上'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours >= 9 && this.hours < 12 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '上午'+ (this.hours<10?'0'+this.hours:this.hours) + ':' + (this.minutes<10?'0'+this.minutes:this.minutes);
                }else if( this.hours == 12 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '中午'+ this.hours + ':' + this.minutes;
                }else if ( this.hours > 12 && this.hours < 18 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '下午'+(this.hours-12) + ':' + this.minutes;
                }else if( this.hours >= 18 && this.hours <22 ){
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '晚上'+(this.hours-12) + ':' + this.minutes;
                }else{
                    this.txmethoddesc = '每周' + (this.txtime_mz_weekday==0?'日':this.txtime_mz_weekday) + '深夜'+(this.hours-12) + ':' + this.minutes;
                }
            }
            else if(this.txmethod == 4){
                //每月
                var method_y = this.txtime_my_day;
                
                if( nowdate == method_y ){
                    if( this.txtime_my_hm <= (nowhours<10?'0'+nowhours:nowhours) + '' + (nowminutes<10?'0'+nowminutes:nowminutes) ){
                        nowmonth = nowmonth + 1;			
                    }
                }else if( nowdate < method_y ){
                    nowdate = method_y;
                }else if( nowdate > method_y ){
                    nowdate = method_y;
                    nowmonth = nowmonth + 1;
                }
                if( nowmonth > 12 ){
                    nowmonth = 1;
                    nowyear = nowyear + 1;
                }
                var nexttime = nowyear + '-' + (nowmonth<10?'0'+nowmonth:nowmonth) + '-' + (nowdate<10?'0'+nowdate:nowdate) + ' ' + this.txtime_my_hm + ':00';
                var hours = new Date(nexttime).getHours();     
                var minutes = new Date(nexttime).getMinutes();           
                if( hours >= 0 && hours < 6 ){
                    this.txmethoddesc = '每月' + method_y + '日凌晨'+ (hours<10?'0'+hours:hours) + ':' + (minutes<10?'0'+minutes:minutes);
                }else if( hours>= 6 && hours < 9 ){
                    this.txmethoddesc = '每月' + method_y + '日早上'+ (hours<10?'0'+hours:hours) + ':' + (minutes<10?'0'+minutes:minutes);
                }else if( hours >= 9 && hours < 12 ){
                    this.txmethoddesc = '每月' + method_y + '日上午'+ (hours<10?'0'+hours:hours) + ':' + (minutes<10?'0'+minutes:minutes);
                }else if( hours == 12 ){
                    this.txmethoddesc = '每月' + method_y + '日中午'+ hours + ':' + minutes;
                }else if ( hours > 12 && hours < 18 ){
                    this.txmethoddesc = '每月' + method_y + '日下午'+(hours-12) + ':' + minutes;
                }else if( hours >= 18 && hours <22 ){
                    this.txmethoddesc = '每月' + method_y + '日晚上'+(hours-12) + ':' + minutes;
                }else if( hours >= 22 && hours <24 ){
                    this.txmethoddesc = '每月' + method_y + '日深夜'+(hours-12) + ':' + minutes;
                }
                this.txnexttime = nexttime;
                this.day = method_y;                
                this.hours = hours;
                this.minutes = minutes;
            }
            else if(this.txmethod == 5){
                //每年
                var sendmethod_ny = this.txtime_mn_month;
                var sendmethod_nr = this.txtime_mn_day;
                
                var txsettime = (sendmethod_ny<10?'0'+sendmethod_ny:sendmethod_ny) + '' + (sendmethod_nr<10?'0'+sendmethod_nr:sendmethod_nr) + this.txtime_mn_hm;
                var nowtime = (nowmonth<10?'0'+nowmonth:nowmonth)+''+(nowdate<10?'0'+nowdate:nowdate)+''+(nowhours<10?nowhours:nowhours)+':'+(nowminutes<10?nowminutes:nowminutes);
                if( txsettime <= nowtime ){
                    nowyear = nowyear + 1;
                }
                var nexttime = nowyear + '-' + (sendmethod_ny<10?'0'+sendmethod_ny:sendmethod_ny) + '-' + (sendmethod_nr<10?'0'+sendmethod_nr:sendmethod_nr) + ' ' + this.txtime_mn_hm + ":00";
                var hours_n = new Date(nexttime).getHours();
                var minutes_n = new Date(nexttime).getMinutes();
                if( hours_n >= 0 && hours_n < 6 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日凌晨'+ (hours_n<10?'0'+hours_n:hours_n) + ':' + (minutes_n<10?'0'+minutes_n:minutes_n);
                }else if( hours_n>= 6 && hours_n < 9 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日早上'+ (hours_n<10?'0'+hours_n:hours_n) + ':' + (minutes_n<10?'0'+minutes_n:minutes_n);
                }else if( hours_n >= 9 && hours_n < 12 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日上午'+ (hours_n<10?'0'+hours_n:hours_n) + ':' + (minutes_n<10?'0'+minutes_n:minutes_n);
                }else if( hours_n == 12 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日中午'+ hours_n + ':' + minutes_n;
                }else if ( hours_n > 12 && hours_n < 18 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日下午'+ (hours_n-12) + ':' + minutes_n;
                }else if( hours_n >= 18 && hours_n <22 ){
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日晚上'+ (hours_n-12) + ':' + minutes_n;
                }else{
                    this.txmethoddesc = '每年' + sendmethod_ny + '月' + sendmethod_nr + '日深夜'+ (hours_n-12) + ':' + minutes_n;
                }
                this.txnexttime = nexttime;
                this.month = sendmethod_ny;
                this.day = sendmethod_nr;
                this.hours = hours_n;
                this.minutes = minutes_n;
            }
            let data = {'id':this.id,'txtitle':this.txtitle,'txcontent':this.txcontent,'txtype':this.txtype,'txmethod':this.txmethod,'txmethoddesc':this.txmethoddesc,'nexttime':this.txnexttime,'sendmethod':this.sendmethod,'month':this.month,'day':this.day,'hours':this.hours,'minutes':this.minutes,'year':this.year,'weekday':this.weekday,'mobile':this.mobile};
            // console.log(JSON.stringify(data));
            let that = this;
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/updtixing.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    window.opener.document.getElementById("settx").style.display = "none";
                    window.opener.document.getElementById("settxok").style.display = "block";
                    window.opener.document.getElementById("settxmethoddesc").innerHTML = "提醒：" + that.txmethoddesc + "";
                    window.close();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/kingtime/memorandumtxedit.vue